import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { TOUR_TYPES } from 'lib/utils/CONSTANTS';
import { defaultNS } from 'next-i18next.config';
import { HydrationWrapper } from 'views/common/components';
import { TourReviewsView } from 'views/tours-module/TourReviewsView';
import { handleReviewsSSR } from 'views/tours-module/TourReviewsView/utils/handleReviewsSSR';

const TourReviewsPage = (props) => {
  const { serverData } = props;
  return (
    <>
      <HydrationWrapper>
        <TourReviewsView serverData={serverData} tourType={TOUR_TYPES.GUIDED} />
      </HydrationWrapper>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const { locale } = ctx;
  let serverData = null;
  serverData = await handleReviewsSSR(ctx, TOUR_TYPES.GUIDED);
  if (serverData.redirect) {
    return serverData;
  }
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_tours_reviews_page',
        'fe_er_reviews_title',
        'fe_er_reviews_card',
        'fe_er_my_review',
        'fe_er_common_detailed_rating',
        'fe_er_common_main_widget',
        'fe_er_auth_overlay',
        'fe_er_auth',
        'fe_er_common_reviews',
        'fe_er_tour_package_selector',
        'fe_er_best_price_guarantee',
      ])),
      ...serverData,
    },
  };
}
export default TourReviewsPage;
